export default __webpack_public_path__ + "static/media/default.6ac55a064f4bef6e417fce8e5d42035a.svg";